import React from 'react';
import { Box, Heading } from 'rebass';

import config from 'config';

const LoginPageHeader = props => (
    <Box>
        <img
            height="40"
            src={`${config.UI_SUFFIX}/dscout-logo.svg`}
            alt="Private Panels Logo"
            style={{ margin: '0 auto 24px', display: 'block' }}
        />
        <Heading mb="24px" color="#001233" fontWeight={600} textAlign="center">
            {props.children}
        </Heading>
    </Box>
);

export default LoginPageHeader;
